export default "__VITE_ASSET__eae3f7d6__"